export const FAILURE_CLASSIFICATIONS = [
  'dependency_timeout',
  'dependency_unavailable',
  'auth_failure',
  'resource_exhaustion',
  'rate_limit',
  'config_error',
  'deployment_regression',
  'network_connectivity',
  'certificate_issue',
  'queue_backlog',
];

export const SEVERITY_OPTIONS = ['low', 'medium', 'high', 'critical'];

export const NEXT_ACTIONS = [
  'investigate_database_service',
  'check_downstream_latency',
  'inspect_auth_service',
  'review_recent_deployments',
  'verify_network_connectivity',
  'inspect_connection_pool',
  'review_queue_depth',
  'inspect_resource_limits',
  'verify_certificates',
  'inspect_dependency_health',
];

export const SCORING = {
  classification: 10,
  severity: 5,
  nextAction: 10,
  perfect: 25,
};

export const DAILY_CHALLENGE = {
  id: 'challenge-2026-03-31',
  date: '2026-03-31',
  logLines: [
    '2026-03-30T13:41:22Z ERROR api-gateway',
    'connect ECONNREFUSED 10.1.4.22:5432',
    'retry attempt 1 failed',
    'retry attempt 2 failed',
    'upstream request aborted after 30000ms',
  ],
  correctAnswer: {
    classification: 'dependency_unavailable',
    severity: 'high',
    nextAction: 'investigate_database_service',
    confidence: 0.91,
    explanation:
      'The ECONNREFUSED error on port 5432 (PostgreSQL default port) combined with failed retries and upstream abort indicates the database service is completely unreachable. Severity is high because the api-gateway is blocking requests. Immediate action is to investigate the database service health.',
  },
};

export const EXAMPLE_LOG_LINES = [
  '2026-03-30T13:41:22Z ERROR api-gateway',
  'connect ECONNREFUSED 10.1.4.22:5432',
  'retry attempt 1 failed',
  'retry attempt 2 failed',
  'upstream request aborted after 30000ms',
];

export const EXAMPLE_RESULT = {
  classification: 'dependency_unavailable',
  severity: 'high',
  nextAction: 'investigate_database_service',
  confidence: 0.91,
};
